import React, { ReactNode } from 'react';
import './StatsElementGridFootnote.scss';

interface Props {
  footnote?: ReactNode;
}

const StatsElementGridFootnote: React.FC<Props> = ({ footnote }) => {
  if (!footnote) {
    return null;
  }

  return (
    <div className="StatsElementGridFootnote">
      <b>Note: </b>
      {footnote}
    </div>
  );
};

export default StatsElementGridFootnote;
